export default {"src":"/_next/static/media/arrow_first.40224e2b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};